import {
  Button,
  Typography,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import { Stack } from "@mui/material";
import Image from "next/image";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import AgapeSlider from "../../../../common/slider/AgapeSlider";
import React from "react";
import BasicModal from "../../../../basicModal";
import modalImage from "../../../../../public/assets/images/modalImage.svg";
import RoundButton from "../../../../common/button/RoundButton";
import { useRouter } from "next/router";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "406px",
    height: "190px",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: "#fff",
    boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.10)",
    borderRadius: "10px",
    "&:hover": {
      boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "370px",
      height: "190px",
    },
    "@media only screen and (max-width: 390px)": {
      width: "335px",
      height: "190px",
    },
  },
  div: {
    padding: 7,
    display: "flex",

    alignItems: "center",
    justifyContent: "center",
  },
  t1: {
    color: "#009693",
    fontSize: "16px",
    fontWeight: "bold",
    padding: 10,
  },
  t3: {
    color: "#292929",
    fontSize: "16px",
    fontWeight: "bold",
    padding: 10,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  t4: {
    color: "#292929",
    fontSize: "16px",
    fontWeight: "bold",
    padding: "5px 0",
  },
  t2: {
    color: "#292929",
    fontSize: "16px",
    padding: 3,
    paddingTop: 0,
  },
  title: {
    color: "#292929",
    fontSize: "18px !important",
    fontWeight: "bold",
    "@media only screen and (max-width: 600px)": {
      fontSize: "14px !important",
    },
  },
  stateIcon: {
    color: "#009693",
    width: "30px",
    height: "30px",
  },
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  },
  closeBtn: {
    width: "100%",
    borderRadius: "15px",
    backgroundColor: "#009693",
    margin: "30px 0 0 0",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#009693",
      boxShadow: "none",
    },
  },
  supBtn: {
    width: "30%",
    "@media only screen and (max-width: 600px)": {
      width: "90%",
    },
  },
}));

const DigiKalaCard = ({ data }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [currentItem, setCurrentItem] = React.useState(null);
  const Router = useRouter();
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleOpen = (item) => {
    setCurrentItem(item);
    setOpen(true);
  };
  const handleClicked = () => {
    Router.push(data?.digikala_url);
  };

  return (
    <Stack
      sx={{ marginTop: "50px", display: "flex", justifyContent: "center" }}
    >
      <Typography className={classes.title}>
        کالاهای مورد نیاز موسسه(همکاری مشترک آگاپه و دیجی کالا)
      </Typography>
      <AgapeSlider
        listLength={data.length}
        slidesToShowDesktop={3}
        slidesToShowTablet={2}
        slidesToShowMobile={1}
        arrow
        autoplay
        infinite
      >
        {data?.data?.map((item, index) => (
          <div className={classes.div} dir="rtl" key={index}>
            <Stack className={classes.container}>
              <Stack
                sx={{
                  borderLeft: "1px solid #B6B3B3",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40%",
                }}
              >
                {item.image_url && (
                  <Image
                    src={item.image_url}
                    placeholder="blur"
                    blurDataURL={item.image_url}
                    alt={item.title}
                    width={"200px"}
                    height={"170px"}
                    // layout="responsive"
                    style={{
                      borderTopRightRadius: "10px",
                      borderBottomRightRadius: "10px",
                    }}
                  />
                )}
              </Stack>
              <Stack sx={{ width: "60%" }}>
                <Typography variant="h4" className={classes.t3}>
                  {item.title}
                </Typography>
                <Stack direction={"row"}>
                  <PinDropOutlinedIcon className={classes.stateIcon} />
                  <Typography variant="h5" className={classes.t2}>
                    {item?.city?.name}
                  </Typography>
                </Stack>
                <Typography variant="h4" className={classes.t3}>
                  {item.description}
                </Typography>
                <Typography
                  onClick={() => handleOpen(item)}
                  className={classes.t1}
                  style={{ cursor: "pointer" }}
                >
                  مشاهده جزيات
                </Typography>
              </Stack>
            </Stack>
          </div>
        ))}
      </AgapeSlider>
      <Stack
        style={{
          display: "flex",
          alignItems: isMobile ? "center" : "flex-end",
          marginTop: "10px",
        }}
      >
        <RoundButton
          fontSize="1.4rem"
          onClick={handleClicked}
          className={classes.supBtn}
        >
          خرید کالا برای موسسه
        </RoundButton>
      </Stack>
      <BasicModal open={open} setOpen={setOpen}>
        <Stack direction="column" alignItems="center" justifyContent="center">
          {currentItem && (
            <>
              <Image
                src={modalImage}
                placeholder="blur"
                blurDataURL={modalImage}
                alt={modalImage}
                width={"121px"}
                height={"99px"}
                style={{
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
              />
              <Stack
                borderBottom={"1px solid #B6B3B3"}
                borderTop={"1px solid #B6B3B3"}
                paddingY={"10px"}
              >
                <Typography variant="h4" className={classes.t4}>
                  {currentItem.description}
                </Typography>
              </Stack>
              <Button
                onClick={() => setOpen(false)}
                className={classes.closeBtn}
              >
                بستن
              </Button>
            </>
          )}
        </Stack>
      </BasicModal>
    </Stack>
  );
};

export default DigiKalaCard;
